import { get } from 'svelte/store';
import { user, state } from './data-store'
import { elementDisplay, isUndefined } from './utilities'

export function setupModeAndBanner(user_record) {
    setText('login-as-text', loggedInAs(user_record.username));
    setText('login-as-text-dummy', loggedInAs(user_record.username));
};

export function loggedInAs(username) {
    let logged_in_as = `Logged in as ${username}`;
    return logged_in_as;
};

export function hideMaintenancePanels() {
    var popups = [
        'messages-maintenance',
        'partners-maintenance',
        'my-name-maintenance',
        'players-maintenance',
    ]
    for (var panel of popups) {
        elementDisplay(panel, 'none')
    }
}

export function switchGreetingValidation() {
    let message = '';
    let mode = get(state).mode;
    let user_store = get(user);

    let greeting_button = document.getElementById('greeting-button');
    let valediction_button = document.getElementById('valediction-button');
    let display_message_control = document.getElementById('display-message');
    if (mode == 'g') {
        greeting_button.className = 'greeting-button-selected select-button';
        valediction_button.className = 'valediction-button-deselected select-button';
        display_message_control.className = 'greeting-button-deselected display-message';
        let selected_greeting = user_store.selected_greeting;

        message = buildMessage();

    } else {
        greeting_button.className = 'greeting-button-deselected select-button';
        valediction_button.className = 'valediction-button-selected select-button';
        display_message_control.className = 'valediction-button-deselected display-message';
        let selected_valediction = user_store.selected_valediction;

        message = buildMessage();
    }
    return message;
}

export function buildMessage() {
    let message = '';
    let state_store = get(state)
    if (get(state).mode == 'g') {
        message = get(user).selected_greeting;
    } else {
        message = get(user).selected_valediction;
    }

    let names = getNamesText(state_store.partner, get(user).my_name);
    let opps = getOpponentsText(state_store.first_names);
    let system = getSystemText(state_store.system)
    message = parseTokens(message, opps, names, system);

    navigator.clipboard.writeText(message);

    let message_field = document.querySelector('#display-message')
    message_field.value = message
    state_store.message = message;
    return message;
}

export function switchToGreeting() {
    let state_store = get(state)
    state_store.mode = 'g';
    state.set(state_store)
    return switchGreetingValidation();
}

function parseTokens(text, opps, names, system) {
    const SPACE_REPLACE = 'space-replace-for-options';
    text = text.replaceAll(SPACE_REPLACE, ' ');
    text = text.replaceAll('&lt', '<');
    text = text.replaceAll('&gt', '>');
    text = text.replace("<opps>", opps);
    text = text.replace("<names>", names);
    text = text.replace("<system>", system);
    return text
}

function getOpponentsText(first_names) {
    if (! first_names || (!first_names[0] && !first_names[1])) {
        return "<opponents>"
    }
    if (!first_names[0]) {
        return `${first_names[1]} and <opponent>`
    }
    if (!first_names[1]) {
        return `${first_names[0]} and <opponent>`
    }
    return `${first_names[0]} and ${first_names[1]}`
}

function getNamesText(partner, my_name) {
    if (!partner) {
        partner = Object.keys(get(user).partners).pop();
    }
    if (!partner) {
        partner = '<partner>';
    }
    if (!my_name) {
        my_name = '<my name>';
    }
    return `${partner} and ${my_name}`;
}

function getSystemText(system) {
    if (!system) {
        return '<system>';
    }
    get(state).system = system;
    return system;
}

export function assignEventToChat() {
    var radioButtonSection = document.getElementsByName('partner-chat');
    for (var i = 0; i < radioButtonSection.length; i++) {
            radioButtonSection[i].onclick = function() {
                navigator.clipboard.writeText(this.value);
                // elementDisplay('partner-chat', 'none')
            }
        }
    }

export function assignPartnerData(partners, username) {
    if (isUndefined(username)) {
        return;
    }
    username = username.toLowerCase();
    let partner = {
        name: '',
        system: '',
        notes: '',
    }
    if (username in partners) {
        partner.name = partners[username].name;
        partner.system = partners[username].system;
        partner.notes = partners[username].notes;
        partner.chat = partners[username].chat;
    };
    return partner;
};

let card_conversions = {
    'S': '<span style="font-size: 1.5em;">&spades;</span>',
    'H': '<span style="font-size: 1.5em; color: red;">&hearts;</span>',
    'D': '<span style="font-size: 1.5em; color: red;">&diams;</span>',
    'C': '<span style="font-size: 1.5em;">&clubs;</span>',
}

export function textToSuit(text) {
    text = text.replaceAll('!s', '!S');
    text = text.replaceAll('!h', '!H');
    text = text.replaceAll('!d', '!D');
    text = text.replaceAll('!c', '!C');

    text = text.replaceAll('!S', card_conversions['S']);
    text = text.replaceAll('!H', card_conversions['H']);
    text = text.replaceAll('!D', card_conversions['D']);
    text = text.replaceAll('!C', card_conversions['C']);
    return '<div>' + text + '</div>';
}

export function suitToText(text) {
    text = text.replaceAll('<div>', '');
    text = text.replaceAll('</div>', '');

    for (const [key, value] of Object.entries(card_conversions)) {
        text = text.replaceAll(value, `!${key}`);
      }
    return text;
}